import React from 'react';
import Carousel from 'react-material-ui-carousel';
import { Box, Typography } from '@mui/material';

import img1 from '../../assets/instalacion1.webp';
import img2 from '../../assets/instalacion2.webp';
import img3 from '../../assets/instalacion3.webp';

const items = [
  {
    image: img1,
    description:
      'Espacios modernos y completamente equipados para prácticas y talleres especializados, ideales para garantizar un aprendizaje práctico y de calidad.',
  },
  {
    image: img2,
    description:
      'Estación individual diseñada para sesiones prácticas, equipada con tecnología de última generación para que los estudiantes desarrollen habilidades técnicas.',
  },
  {
    image: img3,
    description:
      'Vista panorámica de nuestras instalaciones, un entorno pensado para maximizar la experiencia educativa, combinando tecnología avanzada y confort.',
  },
];

const NuestrasInstalaciones = () => {
  return (
    <Box
      sx={{
        py: 6,
        px: { xs: 2, sm: 4 },
        backgroundColor: '#ffffff',
        textAlign: 'center',
        borderRadius: '16px',
      }}
    >
      {/* Título */}
      <Typography variant="h4" sx={{ fontWeight: 'bold', mb: 2, color: 'rgb(41, 54, 54)' }}>
        Nuestras <span style={{ color: '#718895' }}>Instalaciones</span>
      </Typography>
      <Typography variant="body1" sx={{ mb: 4, color: '#5a7184' }}>
        Descubre el entorno ideal para aprender y practicar.
      </Typography>

      {/* Carrusel */}
      <Carousel
        animation="slide"
        indicators
        navButtonsAlwaysVisible
        sx={{ maxWidth: '900px', margin: '0 auto' }}
      >
        {items.map((item, index) => (
          <Box
            key={index}
            sx={{
              position: 'relative',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '16px',
              overflow: 'hidden',
              backgroundColor: '#ffffff',
              height: { xs: 'auto', md: '500px' },
              px: 2,
              pb: 3,
            }}
          >
            <Box
              component="img"
              src={item.image}
              alt={`Instalación ${index + 1}`}
              loading="lazy"
              sx={{
                width: '100%',
                maxHeight: { xs: 300, sm: 400, md: 450 },
                objectFit: 'cover',
                borderRadius: '16px',
                mb: 2,
              }}
            />
            <Typography variant="body2" sx={{ color: '#5a7184', lineHeight: 1.5, fontStyle: 'italic' }}>
              {item.description}
            </Typography>
          </Box>
        ))}
      </Carousel>
    </Box>
  );
};

export default React.memo(NuestrasInstalaciones);
